/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductRoadmapCreate } from '../models/ProductRoadmapCreate';
import type { ProductRoadmapEdit } from '../models/ProductRoadmapEdit';
import type { ProductRoadmapEmbedConfigResponse } from '../models/ProductRoadmapEmbedConfigResponse';
import type { ProductRoadmapResponse } from '../models/ProductRoadmapResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProductRoadmapService {

    /**
     * Create Product Roadmap
     * Create a roadmap for a timeframe (admins) or an accessible workstream.
     * @param requestBody
     * @returns ProductRoadmapResponse Successful Response
     * @throws ApiError
     */
    public static createProductRoadmapApiV1ProductRoadmapPost(
        requestBody: ProductRoadmapCreate,
    ): CancelablePromise<ProductRoadmapResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/product-roadmap',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Edit Product Roadmap
     * Edit a roadmap's title and URL using its scope's write permissions.
     * @param roadmapId
     * @param requestBody
     * @returns ProductRoadmapResponse Successful Response
     * @throws ApiError
     */
    public static editProductRoadmapApiV1ProductRoadmapRoadmapIdPatch(
        roadmapId: number,
        requestBody: ProductRoadmapEdit,
    ): CancelablePromise<ProductRoadmapResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/product-roadmap/{roadmap_id}',
            path: {
                'roadmap_id': roadmapId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Product Roadmap
     * Delete a roadmap for a timeframe (admins) or an accessible workstream.
     * @param roadmapId
     * @returns void
     * @throws ApiError
     */
    public static deleteProductRoadmapApiV1ProductRoadmapRoadmapIdDelete(
        roadmapId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/product-roadmap/{roadmap_id}',
            path: {
                'roadmap_id': roadmapId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Product Roadmap Embed Config
     * Return the linked document for a workstream or timeframe.
     * @param timeframeId
     * @param workstreamId
     * @returns ProductRoadmapEmbedConfigResponse Successful Response
     * @throws ApiError
     */
    public static getProductRoadmapEmbedConfigApiV1ProductRoadmapEmbedConfigGet(
        timeframeId?: (number | null),
        workstreamId?: (number | null),
    ): CancelablePromise<ProductRoadmapEmbedConfigResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/product-roadmap/embed-config',
            query: {
                'timeframe_id': timeframeId,
                'workstream_id': workstreamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
